import { useRef, useCallback } from 'react';
import { Animated, NativeScrollEvent, NativeSyntheticEvent } from 'react-native';

interface ScrollHookResult {
  /** 是否已滚动超过阈值 */
  isScrolled: boolean;
  /** 滚动透明度 0→1（越滚越大） */
  opacity: Animated.Value;
  /** 反向透明度 1→0（越滚越小） */
  reverseOpacity: Animated.Value;
  /** ScrollView 的 onScroll 回调 */
  handleScroll: (e: NativeSyntheticEvent<NativeScrollEvent>) => void;
}

export const useScrollHooks = (
  scrollY: number = 80,
  optionY: number = 100
): ScrollHookResult => {
  const opacityRef = useRef(new Animated.Value(0)).current;
  const reverseOpacityRef = useRef(new Animated.Value(1)).current;
  const isScrolledRef = useRef(false);

  const handleScroll = useCallback((e: NativeSyntheticEvent<NativeScrollEvent>) => {
    const offsetY = e.nativeEvent.contentOffset.y;

    isScrolledRef.current = offsetY > scrollY;

    const progress = Math.min(Math.max(offsetY / optionY, 0), 1);

    opacityRef.setValue(progress);
    reverseOpacityRef.setValue(1 - progress);
  }, [scrollY, optionY, opacityRef, reverseOpacityRef]);

  return {
    isScrolled: isScrolledRef.current,
    opacity: opacityRef,
    reverseOpacity: reverseOpacityRef,
    handleScroll,
  };
};
